import React from 'react';
import { SEOHeadNachDemUnfall } from '../components/SEOHeadNachDemUnfall';
import { Header } from '../components/Header';
import { HeroNachDemUnfall } from '../components/nach-dem-unfall/HeroNachDemUnfall';
import { KurzErklaertBox } from '../components/nach-dem-unfall/KurzErklaertBox';
import { SchrittFuerSchritt } from '../components/nach-dem-unfall/SchrittFuerSchritt';
import { TypischeFehler } from '../components/nach-dem-unfall/TypischeFehler';
import { WannGutachten } from '../components/nach-dem-unfall/WannGutachten';
import { MiniGlossarNachUnfall } from '../components/nach-dem-unfall/MiniGlossarNachUnfall';
import { FAQNachDemUnfall } from '../components/nach-dem-unfall/FAQNachDemUnfall';
import { AbschlussNachUnfall } from '../components/nach-dem-unfall/AbschlussNachUnfall';
import { Footer } from '../components/Footer';
import { MobileStickyCTA } from '../components/MobileStickyCTA';

const NachDemUnfallPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHeadNachDemUnfall />
      <Header />
      <main>
        <HeroNachDemUnfall />
        <KurzErklaertBox />
        <SchrittFuerSchritt />
        <TypischeFehler />
        <WannGutachten />
        <MiniGlossarNachUnfall />
        <FAQNachDemUnfall />
        <AbschlussNachUnfall />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

export default NachDemUnfallPage;